import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getQueryParamForDetails, sourceType } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findTrendResearchProductsBySource } from '@services/trendResearch';

const SimilarProduct = ({ singleProduct, typeOfSource }) => {
	let queryParam = getQueryParamForDetails(singleProduct);
	const dispatch = useDispatch();
	const location = useLocation();
	const [similarProducts, setSimilarProducts] = useState([]);
	const [totalElement, seTotalElement] = useState(0);
	const { source } = location?.state || {};

	const fetchProducts = async (offset = 0) => {
		try {
			dispatch(openLoader());
			const response = await findTrendResearchProductsBySource(
				sourceType[typeOfSource || source],
				queryParam + `&page=${offset}&size=20`
			);
			if (!response.data.length) {
				dispatch(closeLoader());
				return;
			}

			setSimilarProducts(response.data);
			seTotalElement(response.totalElements);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	useEffect(() => {
		if (queryParam !== '') {
			fetchProducts();
		}
	}, [singleProduct, queryParam]);

	const handleRoute = () => {
		const newUrl = `/trends/similar-products`;
		// Open the new URL in a new tab with the window.open method
		sessionStorage.setItem(
			'selectedItem',
			JSON.stringify({ ...singleProduct, source: typeOfSource || source })
		);
		window.open(newUrl, '_blank'); // '_blank' opens in a new tab
	};

	return (
		<div className="trending-product similar-product border-0">
			<div className="section-title d-flex align-items-center justify-content-between pb-3">
				<p className="medium-14 gray_dark_01">View Similar Products ({totalElement})</p>
				<p onClick={handleRoute} className="medium-14 gray_dark_01 cursor-pointer">
					View all
				</p>
			</div>
			<div className="all-products-item">
				{similarProducts.length > 0 &&
					similarProducts?.slice(0, 4).map((singleProduct, index) => (
						<div key={index} className="single-design-card trend-product-card">
							<div className="card-top">
								<img src={singleProduct.imageUrl} alt="card-image" />
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default SimilarProduct;
